import React, { Component} from 'react';
import { connect } from "react-redux";
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, UncontrolledTooltip, Card, CardBody, CardHeader } from "reactstrap";
import { NotificationManager } from "react-notifications";
import LoadingSpinner from "../../components/LoadingSpinner/index";
import DataTable from "../../components/Table/Table";
import "react-table/react-table.css";
import { Link } from "react-router-dom";
import {getApiConfigs, deleteApiKey,setDeveloperPageInfo} from "../../actions/actionDevloper"
import moment from "moment";

class Developers extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            apiId: null,
        };

        this.cancelDelete = this.cancelDelete.bind(this);
        this.deleteConfirm = this.deleteConfirm.bind(this);
        this.deleteApiAction = this.deleteApiAction.bind(this);
        this.handleDeleteSuccess = this.handleDeleteSuccess.bind(this);
        this.handleDeleteError = this.handleDeleteError.bind(this);
    }

    componentDidMount() {
        this.props.getApiConfigs();
    }

    deleteConfirm(apiId){
        this.setState({modal: !this.state.modal,
            apiId: apiId});
    }

    cancelDelete(){
        this.setState({modal: !this.state.modal});
    }

    deleteApiAction(){
        this.props.deleteApiKey(this.state.apiId).
        then(() => this.handleDeleteSuccess()).
        catch(() => this.handleDeleteError());
    }

    handleDeleteSuccess(){
        const {deleteApiErrorMessage} = this.props;
        if(deleteApiErrorMessage) {
            NotificationManager.error(deleteApiErrorMessage,"Delete Api Key Failed", 3000);
        }else{
            NotificationManager.success("Successfully Deleted Api Key","Delete Api Key", 3000);
            this.setState({modal: false});
            this.props.getApiConfigs();
        }
    }

    handleDeleteError(){
        const {deleteApiError} = this.props;
        if(deleteApiError){
            NotificationManager.error(deleteApiError,"Failed to Delete Api Key", 3000);
            this.props.history.push("/developers");
        }else{
            NotificationManager.error("Failed to Delete Api Key","Delete Api Key", 3000);
            this.props.history.push("/developers");
        }
    }

    render() {
        if (this.props.getAPILoading) {
            return (<div> <LoadingSpinner /></div>);
        }

        const {apis} = this.props;

        const tableColumns = [
          {
            type: "text",
            name: "Name",
            accessor: "name",
            filterable: true,
            sortable: true,
          },
          {
            type: "text",
            name: "API Key",
            accessor: "api_key",
            filterable: true,
            sortable: true,
          },
          {
            type: "flag",
            name: "Enabled",
            accessor: "enabled",
            filterable: true,
            sortable: true,
          },
          {
            type: "flag",
            name: "Read Only",
            accessor: "read_only",
            filterable: true,
            sortable: true,
          },
          {
            type: "date",
            name: "Created",
            accessor: "created",
            filterable: true,
            sortable: true
          },
          {
            type: "date",
            name: "Last Used",
            accessor: "last_used",
            filterable: true,
            sortable: true,
          },
        ];

        const actions = [
            { id: "view", icon: "fa-eye", description: "View" },
            { id: "edit", icon: "fa-pencil", description: "Edit" },
            { id: "delete", icon: "fa-trash", description: "Delete" },
        ];

        const onAction = (action, item) => {
            switch (action) {
                case "view":
                    this.props.history.push(`/viewapi/${item.api_id}`);
                break;

                case "edit":
                    this.props.history.push(`/updateapi/${item.api_id}`);
                break;

                case "delete":
                    this.deleteConfirm(item.api_id);
                break;
            }
        }

        return(
            <div className="profile-page">
                <Row>
                    <Col sm={{ size: 10, order: 3, offset: 1 }}>
                        <Card >
                            <CardHeader>
                            <div className="title-head">
                                <i className="fa fa-code-fork"></i> <strong>API Keys</strong></div>
                                <Link className="pull-right add-btn" to={{ pathname: "/createapi" }}>
                                    <button className="pull-right adduser-btn" size="sm" color="dark">
                                    <i className="fa fa-plus" aria-hidden="true"></i>
                                       Add API Key
                                    </button>
                                </Link>
                            </CardHeader>
                            <CardBody className="p-0">
                                <p className = "px-4">
                                    Kasm Workspaces allows developers to extend the systems functionality. Create API keys to leverage the Developer API.
                                    API documentation can be found at <a href="https://docs.kasmweb.com">docs.kasmweb.com</a>.
                                </p>
                                <DataTable
                                    id="developers"
                                    data={apis}
                                    columns={tableColumns}
                                    actions={actions}
                                    onAction={onAction}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Modal isOpen={this.state.modal} toggle={this.cancelDelete} className="user-modal">
                    <ModalHeader toggle={this.cancelDelete}>Are you sure you want to delete this key?
                    </ModalHeader>
                    <ModalFooter>
                        <Button onClick={this.cancelDelete} 
                        className="cancel-button"
                        size="sm" color=" basic"> Close</Button>
                        <Button onClick={this.deleteApiAction} 
                        className="delete-button"
                        size="sm" color="danger">Delete</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }

}

export default connect(state => ({
        apis: state.develop.apis || [],
        getAPILoading: state.develop.getAPILoading || false,
        getAPIErrorMessage: state.develop.getAPIErrorMessage || false,
        getAPIError: state.develop.getAPIError || null,
        deleteApiErrorMessage: state.develop.deleteApiErrorMessage || null,
        deleteApiError: state.develop.deleteApiError || null,
        deletedApi: state.develop.deletedApi || null,
        deleteAPILoading: state.develop.deleteAPILoading || null,
        pages : {pageSize : state.develop.pageSize, pageNo : state.develop.pageNo},
    }),
    dispatch => ({
        getApiConfigs: () => dispatch(getApiConfigs()),
        deleteApiKey: (data) => dispatch(deleteApiKey(data)),
        setPageInfo : (data)=> dispatch(setDeveloperPageInfo(data)),
    }))(Developers);


// WEBPACK FOOTER //
// ./src/views/Developers/Developers.js